<br>
  <form id="tileDefaultForm" #tileDefaultForm="ngForm">
    <div class="p-grid">
      <div class="p-col-12">
        <h4>Report Tile Defaults</h4>
      </div>

      <div class="p-grid">
        <div style="text-align: center;">
          <app-loading-swirly [isLoading]="isLoading"></app-loading-swirly>
        </div>
        @for (role of allRoles; track role) {
          <div class="p-col-4" style="padding-left: 40px;">
            <app-report-tile-default-section [role]="role" [allReportTiles]="allReportTiles"></app-report-tile-default-section>
          </div>
        }
      </div>
    </div>
  </form>
